<template>
	<div id="app">
		<router-view></router-view>
		<Modal
			v-model="modal1"
			title="提示"
			:footer-hide="true"
		>
			<div class="modal-off-hint">老麒麟眼平台，即将于2025年12月30日下线，不可访问。还未迁移的任务或脚本，请在下线前迁移到新的智慧家庭数智平台。平台地址：<a href="https://data.haier.net/dp/" target="_blank">https://data.haier.net/dp/</a></div>
    </Modal>
	</div>
</template>

<script>
	import "@/assets/css/reset.css";
	import "@/assets/css/common.css";
	import "@/assets/css/iview.css";
  
	export default {
		name: "App",
		data () {
			return {
				modal1: true
			}
		}
	};
</script>

<style>
	html, body, #app {
	    height: 100%;
	}
	
	body {
		background-color: #f5f5f5;
		overflow: hidden;
	}
	.modal-off-hint {
		font-size: 16px;
		line-height: 30px;
		text-indent: 2em;
	}
	.modal-off-hint a {
		color: #2d8cf0;
	}
</style>
